import KBSearchList from './KBSearchList';

export default KBSearchList;
